import type { RootState } from '@/redux';
import type { CampaignQuiz } from '@/services/api/types';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type QuizzesState = { quizzes: CampaignQuiz[]; available: number };

export const state = { available: 0 } as QuizzesState;

export const {
  reducer,
  actions: { setQuizzesData }
} = createSlice({
  initialState: state,
  name: 'quizzes',
  reducers: {
    setQuizzesData: (_, action: PayloadAction<QuizzesState>) => action.payload
  }
});

export const getQuizzes = (state: RootState) => state.quizzes.quizzes;

export const getAvailableQuizzes = (state: RootState) =>
  state.quizzes.available;
